import { returnValueIfExists } from 'lib/server.service';
import { NC_OFFER } from 'constants/constants';

import type { NormalizedNcOffer } from './offersTypes';

export const normalizeNcOffer = (offer: any, data: any) => {
  const { custOffers } = offer;

  if (!custOffers) {
    return null;
  }

  const packages = custOffers.flatMap((offer: any) => offer.packages);

  if (!packages) {
    return null;
  }

  let i = 0;

  while (i < packages.length) {
    const offer = packages[i++];

    if (!offer.isDisplayToDefault
      || offer.psychicTier !== data.psychicTier) {
      // eslint-disable-next-line no-continue
      continue;
    }

    const { defaultMinutes, ...restOffer } = offer;

    return {
      ...restOffer,
      ...returnValueIfExists('purchaseMinutes', defaultMinutes - offer.freeMinutes),
      ...returnValueIfExists('totalMinutes', defaultMinutes),
      ...returnValueIfExists('basePrice', data.basePrice),
      ...returnValueIfExists('extId', data.id),
    } as NormalizedNcOffer;
  }

  return null;
};

export const extractNcOffer = (
  cookies: Record<string, any> = {},
  query: Record<string, any> = {},
) => {
  const cookieOffer = cookies[NC_OFFER];
  const queryOffer = query[NC_OFFER];
  const fallback = queryOffer || null;

  if (!cookieOffer) {
    return fallback;
  }

  return cookieOffer;
};
